import SettingsView from "@/systems/modules/settings/SettingsView.vue";
import info from "@/info";

export default {
    getRoutes: (module) => ([
        {
            name: "modules." + module + ".settings",
            path: "settings",
            component: SettingsView,
            props: route => ({ communityId: route.params.communityId, module: module }),
            meta: {
                authorize: () => info.getModuleInfo(module)?.showSettings === true
            }
        },
    ])
};